module.exports = __webpack_public_path__ + "img/panda_analytics_icon.556ccd85.svg";